module.exports = __webpack_public_path__ + "img/dream-journal_B095GD37N1.c0816251.jpg";